import { Flex, Box, Text, FlexProps } from '@chakra-ui/react'

export const StatsRow = ({
  name,
  value,
  icon,
  styles,
}: {
  name?: string
  value: React.ReactElement | string
  icon?: React.ReactElement
  styles?: FlexProps
}) => {
  return (
    <Flex
      gap={3}
      alignItems={'center'}
      bg={'ninja.700'}
      rounded={'xl'}
      py={name ? 2 : 5}
      px={name ? 3 : 4}
      mb={3}
      {...styles}
    >
      {icon}
      <Box w={'full'} justifyContent={'space-between'} fontWeight={700} fontSize={'sm'}>
        {name && (
          <Text color={'ninja.200'} fontSize={'sm'} mb={icon ? 0 : 1}>
            {name}
          </Text>
        )}
        {value}
      </Box>
    </Flex>
  )
}
